import { render, staticRenderFns } from "./ImportTranslationJsonModal.vue?vue&type=template&id=84f78edc&scoped=true&"
import script from "./ImportTranslationJsonModal.vue?vue&type=script&lang=js&"
export * from "./ImportTranslationJsonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f78edc",
  null
  
)

export default component.exports